import { Button, Checkbox, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useState } from 'react';

const FilterDropdownContent = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, filters, showSelectAll }) => {
  const [searchText, setSearchText] = useState('');

  const filteredItems = filters.filter(item =>
    item.text.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div style={{ padding: 8 }}>
      {showSelectAll && (
        <div style={{ marginBottom: 8 }}>
          <Button
            type="primary"
            size="small"
            onClick={() => setSelectedKeys(filters.map(item => item.value))}
            block
          >
            Seleccionar todos
          </Button>
        </div>
      )}
      <Input
        placeholder="Search in filters"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 8 }}
        prefix={<SearchOutlined />}
      />
      <div style={{ maxHeight: 200, overflow: 'auto', marginBottom: 8 }}>
        {filteredItems.map((item) => (
          <div key={item.value} style={{ padding: '5px 12px' }}>
            <Checkbox
              checked={selectedKeys.includes(item.value)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedKeys([...selectedKeys, item.value]);
                } else {
                  setSelectedKeys(selectedKeys.filter(key => key !== item.value));
                }
              }}
            >
              {item.text}
            </Checkbox>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #f0f0f0', paddingTop: 8 }}>
        <Button size="small" onClick={() => {
          setSearchText('');
          clearFilters();
          confirm();
        }}>
          Reset
        </Button>
        <Button type="primary" size="small" onClick={confirm}>
          OK
        </Button>
      </div>
    </div>
  );
};

export const FilterTAble = (dataIndex, arrayIndexs, showSelectAll = false) => {
  return {
    filters: arrayIndexs,
    onFilter: (value, record) => record[dataIndex].startsWith(value),
    filterSearch: true,
    filterDropdown: (props) => <FilterDropdownContent {...props} showSelectAll={showSelectAll} />
  };
}